import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import { User } from '../models/user';

export interface AppData {
  user: User;
}

type AppContextProviderProps = { children: ReactNode };

const defaultData: AppData = {
  user: {
    name: '',
    userPermissions: [],
    permissions: [],
  },
};

const AppContext = createContext<{
  appData: AppData;
  setAppData: Dispatch<SetStateAction<AppData>>;
}>({
  appData: defaultData,
  setAppData: () => {},
});

const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [appData, setAppData] = useState<AppData>(defaultData);
  const contextValue = useMemo(
    () => ({
      appData,
      setAppData,
    }),
    [appData]
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export { AppContext, AppContextProvider };
